// Shared clipboard for the mini-desktop (desktop icons + File Manager).
// Holds one or many items (multi-select cut/copy).
export const fsClipboard = { items: [], cut: false };

export const clipSet = (items, cut) => { fsClipboard.items = items; fsClipboard.cut = cut; };
export const clipClear = () => { fsClipboard.items = []; fsClipboard.cut = false; };
export const clipHas = (id) => fsClipboard.items.some((x) => x.id === id);

// Virtual parent id of the Desktop surface — separate from File Manager root.
export const DESKTOP_ROOT = "__desktop__";
